module.exports = __webpack_public_path__ + "media/images/photo/Commercial/Commercial-02-a5c4a298259ce22d85e4b60de2747337.png";